export default __webpack_public_path__ + "static/cactus1-6fba611326e0709f83696858e08adb1b.webp";